<template>
    <div v-if="havePages" class="pagination-area">
        <ul class="pagination pagination--blue hidden__xs">
            <template v-if="firstResult">
                <li class="pagination__li pagination__li--disabled"><span class="pagination__link pagination__link--disabled">«</span></li>
            </template>
            <template v-else>
                <li class="pagination__li"><router-link class="pagination__link" rel="prev" :to="getRouteForPage(currentPage - 1)">«</router-link></li>
            </template>
            <template v-for="link in links">
                <li class="pagination__li" :key="link.i" v-if="link.current"><span class="pagination__link pagination__link--active">{{ link.label }}</span></li>
                <li class="pagination__li pagination__li--disabled" :key="link.i" v-else-if="link.label == '...'"><span class="pagination__link">...</span></li>
                <li class="pagination__li" :key="link.i" v-else><router-link :to="link.link" class="pagination__link">{{ link.label }}</router-link></li>
            </template>
            <template v-if="lastResult">
                <li class="pagination__li pagination__li--disabled"><span class="pagination__link">»</span></li>
            </template>
            <template v-else>
                <li class="pagination__li"><router-link class="pagination__link" rel="next" :to="getRouteForPage(currentPage + 1)">»</router-link></li>
            </template>
        </ul>
        <ul class="pagination pagination--blue hidden__sm hidden__md hidden__lg">
            <template v-if="firstResult">
                <li class="pagination__li pagination__li--disabled"><span class="pagination__link">«</span></li>
            </template>
            <template v-else>
                <li class="pagination__li"><router-link class="pagination__link" rel="prev" :to="getRouteForPage(currentPage - 1)">«</router-link></li>
            </template>
            <template v-for="link in linksMobile">
                <li class="pagination__li" :key="link.i" v-if="link.current"><span class="pagination__link pagination__link--active">{{ link.label }}</span></li>
                <li class="pagination__li pagination__li--disabled" :key="link.i" v-else-if="link.label == '...'"><span class="pagination__link">...</span></li>
                <li class="pagination__li" :key="link.i" v-else><router-link class="pagination__link" :to="link.link">{{ link.label }}</router-link></li>
            </template>
            <template v-if="lastResult">
                <li class="pagination__li pagination__li--disabled"><span class="pagination__link">»</span></li>
            </template>
            <template v-else>
                <li class="pagination__li"><router-link class="pagination__link" rel="next" :to="getRouteForPage(currentPage + 1)">»</router-link></li>
            </template>
        </ul>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    props: {
        includeButton: {
            required: false,
            default: true,
        },
    },
    computed: {
        ...mapState('UsedSearchOptions', ['pages', 'resultsLoading']),
        havePages() {
            if (this.pages.length == 0) {
                return false;
            }
            if (this.pages.last_page == 1) {
                return false;
            }
            return true;
        },
        currentPage() {
            return this.pages.current_page;
        },
        firstResult() {
            return (this.pages.current_page == 1) ? true : false;
        },
        lastResult() {
            return (this.pages.current_page >= this.pages.last_page) ? true : false;
        },
        links() {
            let links = [];
            if (!this.havePages) {
                return links;
            }

            let distanceFromFirst = false;
            let distanceFromCurrent = false;
            let distanceFromLast = false;
            for (let index = 1; index <= this.pages.last_page; index++) {
                // Work out distance from each node (first page, current page and last page)
                distanceFromFirst = index - 1;
                distanceFromLast = this.pages.last_page - index;
                distanceFromCurrent = Math.abs(this.pages.current_page - index);
                if (distanceFromFirst == 0 || distanceFromLast == 0 || distanceFromCurrent <= 3) {
                    // Check if there's a jump in index, and add a ... if there is
                    let linksLength = links.length;
                    if (linksLength > 0 && links[linksLength -1] !== '...' && index - links[linksLength -1].label > 1) {
                        links.push({
                            i: index + 's',
                            label: '...',
                            current: false,
                            link: false,
                        });
                    }
                    links.push({
                        i: index,
                        label: index,
                        displayDesktop: true,
                        current: (index == this.pages.current_page) ? true : false,
                        link: (index == this.pages.current_page) ? false : this.getRouteForPage(index),
                    });
                }
            }
            return links;
        },
        linksMobile() {
            let links = [];
            if (!this.havePages) {
                return links;
            }

            let distanceFromFirst = false;
            let distanceFromCurrent = false;
            let distanceFromLast = false;
            for (let index = 1; index <= this.pages.last_page; index++) {
                // Work out distance from each node (first page, current page and last page)
                distanceFromFirst = index - 1;
                distanceFromLast = this.pages.last_page - index;
                distanceFromCurrent = Math.abs(this.pages.current_page - index);
                if (distanceFromFirst == 0 || distanceFromLast == 0 || distanceFromCurrent <= 1) {
                    // Check if there's a jump in index, and add a ... if there is
                    let linksLength = links.length;
                    if (linksLength > 0 && links[linksLength -1] !== '...' && index - links[linksLength -1].label > 1) {
                        links.push({
                            i: index + 's',
                            label: '...',
                            current: false,
                            link: false,
                        });
                    }
                    links.push({
                        i: index,
                        label: index,
                        displayDesktop: true,
                        current: (index == this.pages.current_page) ? true : false,
                        link: (index == this.pages.current_page) ? false : this.getRouteForPage(index),
                    });
                }
            }
            return links;
        }
    },
    methods: {
        previousPage() {
            this.$router.push(this.getRouteForPage(this.pages.current_page - 1));
        },
        nextPage() {
            this.$router.push(this.getRouteForPage(this.pages.current_page + 1));
        },
        getRouteForPage(pageToLoad) {
            if (pageToLoad > this.pages.last_page) {
                pageToLoad = this.pages.last_page;
            }
            if (pageToLoad < 1) {
                pageToLoad = 1;
            }
            // Using spread operator to get around the object being passed by reference reactivity issue
            let newRoute = {};
            newRoute.path = this.$route.path;
            newRoute.query = {...this.$route.query };
            newRoute.query.page = pageToLoad;
            return newRoute;
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/UsedResultsPaging.vue